import React, {Component} from 'react'
import ReactDataGrid from 'react-data-grid/dist/react-data-grid.min'
import {values} from 'lodash'
import {UncontrolledTooltip} from "reactstrap"
import Select, {Creatable} from 'react-select';
import createFilterOptions from 'react-select-fast-filter-options'
import reactSelectStyles from '../../../services/config/reactSelect/reactSelectStyles';
import reactSelectTheme from '../../../services/config/reactSelect/reactSelectTheme';

const {
  ToolsPanel: {AdvancedToolbar: Toolbar, GroupedColumnsPanel},
  Data: {Selectors},
  Draggable: {Container: DraggableContainer},
} = require('react-data-grid-addons/dist/react-data-grid-addons.min.js')


export class LocationsGrid extends Component {
  constructor(props) {
    super(props)

    const {rows, accounts, categories, locations} = props
    this.onAccountSelect = props.onAccountSelect

    this.onCategorySearch = createFilterOptions({options: categories})

    this.state = {
      rows: values(rows),
      accounts,
      categories,
      selectedCategory: null,
      selectedAccount: accounts[0],
      groupBy: [],
      expandedRows: {},
      locations,
      keywords: [],
      totalLocations: 0,
      locationsCompleted: 0,
    }
  }

  getColumns() {

    let columns = [
      {
        key: 'id',
        name: 'ID',
        resizable: true,
        width: 50,
      },
      {
        key: 'name',
        name: 'Company Name'.toUpperCase(),
        editable: true,
        resizable: true,
        width: 180,
      },
      {
        key: 'streetAddress',
        name: 'Street'.toUpperCase(),
        editable: true,
        resizable: true,
        width: 200,
      },

      {
        key: 'locality',
        name: 'LOCALITY (TOWN/CITY)',
        editable: true,
        resizable: true,
        headerRenderer: ({column}) => {
          return (
            <div>
              <span style={{marginRight: '10px'}}>{column.name}</span>
              {this.state.groupBy.indexOf(column.key)
                ? (<span>
                    <UncontrolledTooltip placement={'top'} target={'locality-group'}>
                      {'Group'}
                    </UncontrolledTooltip>
                    <span
                      id='locality-group'
                      className="far fa-object-group"
                      onClick={() => {
                        this.onColumnGroupAdded(column.key)
                      }}
                    />
                  </span>)
                :
                  (<span>
                    <UncontrolledTooltip placement={'top'} target={'locality-group-remove'}>
                      {'Remove Grouping'}
                    </UncontrolledTooltip>
                    <span
                      id='locality-group-remove'
                      className="far fa-object-ungroup"
                      onClick={() => {
                        this.onColumnGroupDeleted(column.key)
                      }}
                    />
                  </span>)
              }
            </div>
          )
        },
        width: 200,
      },
      {
        key: 'region',
        name: 'Region (State/Province)'.toUpperCase(),
        editable: true,
        resizable: true,
        width: 70,
      },
      {
        key: 'postalCode',
        name: 'ZipCode'.toUpperCase(),
        editable: true,
        resizable: true,
        width: 100,
      },
      {
        key: 'country',
        name: 'Country'.toUpperCase(),
        editable: true,
        resizable: true,
        width: 100,
      },
      {
        key: 'phone',
        name: 'Phone'.toUpperCase(),
        width: 120,
        editable: true,
        resizable: true,
      },
      {
        key: 'website',
        name: 'Website'.toUpperCase(),
        resizable: true,
        editable: true,
        width: 200
      },
      {
        key: 'email',
        name: 'Email'.toUpperCase(),
        editable: true,
        resizable: true,
        width: 200,
      },
      {
        key: 'latitude',
        name: 'Latitude'.toUpperCase(),
        editable: true,
        resizable: true,
        width: 100,
      },
      {
        key: 'longitude',
        name: 'Longitude'.toUpperCase(),
        editable: true,
        resizable: true,
        width: 100,
      },
    ];

    return columns
  }

  componentWillReceiveProps(nextProps) {
    this.setState(
      {
        rows: values(nextProps.rows),
      }
    )
  }

  handleGridRowsUpdated({fromRow, toRow, updated}) {
    let rows = this.state.rows.slice()
    for (let i = fromRow; i <= toRow; i++) {
      let rowToUpdate = rows[i]
      let updatedRow = {...rowToUpdate, ...updated}
      rows[i] = updatedRow
    }

    this.setState({rows})
  }

  handleAddRow({newRowIndex}) {
  }

  getRows() {
    return Selectors.getRows(this.state)
  }

  getRowAt(index) {
    let rows = this.getRows();
    return rows[index];
  }

  getSize() {
    return this.getRows().length
  }

  onColumnGroupAdded(colName) {
    let columnGroups = this.state.groupBy.slice(0);
    if (columnGroups.indexOf(colName) === -1) {
      columnGroups.push(colName);
    }
    this.setState({groupBy: columnGroups});
  }

  onColumnGroupDeleted(name) {
    this.setState({groupBy: this.state.groupBy.filter(g => g !== name)});
  }

  onRowExpandToggle({columnGroupName, name, shouldExpand}) {
    let expandedRows = Object.assign({}, this.state.expandedRows);
    expandedRows[columnGroupName] = Object.assign({}, expandedRows[columnGroupName]);
    expandedRows[columnGroupName][name] = {isExpanded: shouldExpand};
    this.setState({expandedRows});
  }

  onLocationAdded() {
    this.setState({locationsCompleted: this.state.locationsCompleted + 1})
  }

  addLocationsSubmitted() {
    // Here we do whatever we have to do the grid and then pass on control.
    // Do we have any selected locations
    if (this.grid.getSelectedRows().length) {
      this.setState({totalLocations: this.grid.getSelectedRows().length, locationsCompleted: 0})
      // here we add only the selectedRows.
      return this.props.onCreateLocationsSubmitted(
        this.state.selectedAccount.value,
        this.state.selectedCategory,
        this.state.keywords.map(x => x.value),
        this.grid.getSelectedRows(),
        this.onLocationAdded.bind(this)
      )
    }
  }

  render() {
    const styles = {
      outerLoader: {
        position: 'relative',
        height: '5px',
        background: (this.state.locationsCompleted === this.state.totalLocations ? '#00B64F' : '#f80'),
        borderColor: '#e7eaec',
        borderWidth: '1px',
        overflow: 'hidden'
      },
      innerLoader: {
        left: `${Math.ceil((this.state.locationsCompleted / this.state.totalLocations) * 100)}%`,
        transition: '.2s all',
        background: '#ddd',
        position: 'absolute',
        top: '0',
        width: '100%',
        height: '5px'
      }
    }

    return (
      <div>
        <div
          className="container-fluid"
          style={{
            position: 'relative',
            minHeight: '250px',
            backgroundColor: 'white',
            marginBottom: '20px',
          }}
        >
          <hr className="content-spacer-top"/>
          <h4>Location Options</h4>
          <form>
            <div className="row">
              <div className="col-md-4 form-group">
                <Select
                  styles={reactSelectStyles()}
                  theme={reactSelectTheme}
                  name="form-field-state"
                  value={this.state.selectedAccount || ''}
                  placeholder="Select Account"
                  options={this.state.accounts}
                  onChange={account => {
                    if (account) this.onAccountSelect(account.value);
                    this.setState({selectedAccount: account})
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-5 form-group">
                <Select
                  value={this.state.selectedCategory
                    ? {label: this.state.selectedCategory, value: this.state.selectedCategory}
                    : null
                  }
                  placeholder={"Select a Category..."}
                  options={this.state.categories}
                  filterOptions={this.onCategorySearch}
                  onChange={(keyword) => {
                    this.setState({selectedCategory: keyword.value})
                  }}
                  clearable={false}
                  autoload={false}
                  backspaceRemoves={true}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 form-group">
                <Creatable
                  styles={reactSelectStyles()}
                  theme={reactSelectTheme}
                  placeholder={"Enter keywords"}
                  value={this.state.keywords}
                  isMulti={true}
                  allowCreate={true}
                  onChange={(keywords) => {
                    if (this.state.keywords.length < 15) {
                      this.setState({keywords: keywords});
                    }
                  }}
                />
              </div>
            </div>
          </form>
          <div className="row">
            <div className="col-md-4 col-md-offset-8">
              <button className="btn btn-secondary"
                      onClick={this.addLocationsSubmitted.bind(this)}>
                + Add Locations
              </button>
            </div>
          </div>
        </div>
        <DraggableContainer>
          <ReactDataGrid
            ref={node => {
              this.grid = node
            }}
            onCellSelected={function () {
              return false
            }}
            enableCellSelect={true}
            columns={this.getColumns()}
            rowGetter={this.getRowAt.bind(this)}
            rowsCount={this.getSize()}
            onGridRowsUpdated={this.handleGridRowsUpdated.bind(this)}
            toolbar={
              (<div>
                <div style={Object.assign({}, styles.outerLoader)}>
                  <div style={Object.assign({}, styles.innerLoader)}/>
                </div>
                <Toolbar style={{height: 'auto'}} onAddRow={this.handleAddRow.bind(this)}>

                  <div className="row">
                    <div className="col-md-3">
                      <GroupedColumnsPanel
                        groupBy={this.state.groupBy}
                        onColumnGroupAdded={this.onColumnGroupAdded.bind(this)}
                        onColumnGroupDeleted={this.onColumnGroupDeleted.bind(this)}
                      />
                    </div>

                    <div className="col-md-9 pull-right" style={{marginTop: "-8px", position: 'relative'}}>

                    </div>
                  </div>
                </Toolbar>
              </div>)
            }
            enableRowSelect={true}
            onRowExpandToggle={this.onRowExpandToggle.bind(this)}
            rowHeight={50}
            minHeight={600}
          />
        </DraggableContainer>
      </div>
    )
  }
}
